import { CommitmentTypes } from 'legacy/lut/components/widgets/public/partner360/commitment/models'
import { ICommitmentData } from 'legacy/lut/services/partner360/commitment/models/apiCommitmentData'

import { Region } from 'clickNgo/configs/geo'

export const getCardTypesOrder = (
  geoRegion: Region | null,
  commitmentItems: ICommitmentData[]
): CommitmentTypes[] => {
  if (!commitmentItems.every((el) => el.CommitmentOrder)) {
    if (geoRegion === Region.AMS) {
      return [CommitmentTypes.PBM, CommitmentTypes.Partner, CommitmentTypes.Manager]
    }

    return [CommitmentTypes.PBM, CommitmentTypes.Manager, CommitmentTypes.Partner]
  }

  const commitmentOrderMap: { [key: number]: CommitmentTypes | undefined } = {}

  commitmentItems.forEach(({ CommitmentOrder, CommitmentType }) => {
    if (!commitmentOrderMap[CommitmentOrder]) {
      commitmentOrderMap[CommitmentOrder] = CommitmentType
    }
  })

  const uniqueOrders = Object.keys(commitmentOrderMap)
    .map(Number)
    .sort((a, b) => a - b)

  return uniqueOrders.map((order) => commitmentOrderMap[order]).filter(Boolean) as CommitmentTypes[]
}
